import React, { PureComponent } from 'react';
import './style.scss';
// import { withLocalize } from 'react-localize-redux';
import Chart from 'react-apexcharts';
import { connect } from 'react-redux';
import numeral from 'numeral';
import lodash from 'lodash';
import { ACTIONS, getTeam1 } from './../../../../../actions/team-1';
// import Loading from '../../../../../components/loading';

class LineChart extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            options: {
                xaxis: {
                    categories: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                },
                colors: ['#6161F2'],
                chart: {
                    id: 'basic-bar',
                    toolbar: {
                        show: false,
                        tools: {
                            download: true | '<img src="img/logo.png" class="ico-download" width="20">',
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: [],
                        },
                        autoSelected: 'zoom',
                    },
                },
            },
            series: [{
                name: 'series-1',
                data: [0.200, 0.223, 0.253, 0.242, 0.259, 0.266, 0.274, 0.279, 0.277, 0.280, 0.290, 0.300],
            }],
            listTitleLineChart : [],
            showLoading: false
        };
    }

    componentDidMount() {
        const id = this.props.id;
        this.props.getTeam1(id);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_INFO_TEAM_1_SUCCESS) {
                let arrMonth = [];
                let arrValue = [];

                if (nextProps.response.graph) {
                    nextProps.response.graph[0].data.forEach(element => {
                        arrMonth.push(`${element.month}月`);
                        arrValue.push(element.value);
                    });
                }
                let self = this;
                let minmax = this.getMinMaxData('1試合平均得点');
                this.setState({
                    listTitleLineChart: nextProps.response.graph,
                    options: {
                        xaxis: {
                            categories: arrMonth,
                        },
                        chart: {
                            id: 'basic-bar',
                            toolbar: {
                                show: false,
                            },
                        },
                        tooltip: {
                            y: {
                                formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                    return self.convertPercentage(value);
                                }
                            }
                        },
                        yaxis: {
                            min: minmax.min,
                            max: minmax.max,
                            labels : {
                                formatter: (value) => {
                                    return numeral(value).format('0.0');
                                }
                            }
                        }
                    },
                    series: [{
                        name: this.props.teamName,
                        data: arrValue,
                    }],
                })
            }
        }
    }

    convertPercentage (number, type){
        if (isNaN(number)) return '0.00';
        switch (type) {
            case '打率':
                number = numeral(number).format('0.000');
                break;
            case 'OPS':
                number = numeral(number).format('0.000');
                break;
            case '救援防御率':
                number = numeral(number).format('0.00');
                break;
            case '先発防御率':
                number = numeral(number).format('0.00');
                break;
            case '1試合平均得点':
                number = numeral(number).format('0.0');
                break;
            case '1試合平均失点':
                number = numeral(number).format('0.0');
                break;
            default:
                // number = numeral(number).format('0.000');
                number = numeral(number).format('0.0');
                break;
        }

        if (number == 0) {
            return 0;
        } else if (number < 1) {
            let srt = number.toString();
            srt = srt.substr(1);
            return srt;
        } else {
            return number;
        }
    }

    getMinMaxData (type) {
        switch (type) {
            case '打率':
                return {
                    max: 0.5,
                    min : 0
                }
            case 'OPS':
                return {
                    max: 1,
                    min : 0
                }
            case '救援防御率':
                return {
                    max: 7,
                    min : 0
                }
            case '先発防御率':
                return {
                    max: 7,
                    min : 0
                }
            case '1試合平均得点':
                return {
                    max: 7,
                    min : 0
                }
            case '1試合平均失点':
                return {
                    max: 7,
                    min : 0
                }
            default:
                break;
        }
    }

    selectShowChart(e, item) {
        const listTitleLineChart = document.querySelectorAll('.title-line-chart');
        let arrMonth = [];
        let arrValue = [];
        item.data.forEach(element => {
            arrMonth.push(element.month);
            arrValue.push(element.value);
        });
        for (let index = 0; index < listTitleLineChart.length; index++) {
            listTitleLineChart[index].classList.remove('active');
            e.target.classList.add('active');
        }
        let minmax = this.getMinMaxData(item.title);
        let self = this;

        this.setState({
            options: {
                xaxis: {
                    categories: arrMonth,
                },
                tooltip: {
                    y: {
                        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                            return self.convertPercentage(value, item.title);
                        }
                    }
                },
                yaxis: {
                    min: minmax.min,
                    max: minmax.max,
                    labels : {
                        formatter: (value) => {
                            if (item.title === '打率') return numeral(value).format('0.00');
                            return numeral(value).format('0.0');
                        }
                    }
                }
            },
            series: [{
                data: arrValue,
            }],
        })
    }

    render() {
        return (
            <div className="chart" style={{height: 347}}>
                <div className="control">
                    <div>
                        {
                            this.state.listTitleLineChart && this.state.listTitleLineChart.length
                                ? this.state.listTitleLineChart.map((val, i) => {
                                    if (i === 0) {
                                        return (
                                            <button onClick={(e) => this.selectShowChart(e, val)} type="button" className="title-line-chart btn-radius active " key={i}>{val.title}</button>
                                        )
                                    } else {
                                        return (
                                            <button onClick={(e) => this.selectShowChart(e, val)} type="button" className="title-line-chart btn-radius " key={i}>{val.title}</button>
                                        )
                                    }
                                })
                                : null
                        }
                    </div>
                    <div className="dropdown-dot" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img src="./../../img/ic_dot_vertical.svg" alt="dot" className=" multi-dot" />
                        <div className="dropdown-menu dropdown-menu-right" >
                            {/* <button onClick={(e) => this.offDropdown(e, 0, value)}
                                className="dropdown-item" type="button">編集</button>
                            <button onClick={(e) => this.offDropdown(e, 1, value)}
                                className="dropdown-item" type="button">削除</button> */}
                        </div>
                    </div>
                </div>
                <div className="mixed-chart">
                    <Chart
                        options={this.state.options}
                        series={this.state.series}
                        type="line"
                        width="100%"
                        height="210"
                    />
                </div>
                <textarea className="text-area" rows="3" placeholder="注釈が入ります" />
            </div>
        );
    }
}
const mapStateToProps = ({ teams }) => {
	return {

		response: teams.response,
        status: teams.status
	};
}

const mapDispatchToProps = dispatch => {
	return {
		getTeam1: (id) => {
            dispatch(getTeam1(id))
        }
	};
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(LineChart);
